import { Outlet } from "react-router-dom";
import { TabsFormLayoutV2 } from "src/framework/form/TabsFormLayoutV2.tsx";
import { useModuleRoutePaths } from "src/system/useModuleRoutePaths.ts";
import { camelToKebabCase } from "@exonn/utils";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";
import { useModule } from "src/system/useModule.tsx";
import { FormAction } from "src/components/Form/Form.types.ts";

export type CreateLayoutV2Props = {
  resource: string;
  layoutForm?: boolean;
};

export function CreateLayoutV2(props: CreateLayoutV2Props) {
  const { resource, layoutForm } = props;
  const { t } = useTranslation();

  const paths = useModuleRoutePaths({
    resource,
  });

  const { formTabs: formTabsConfig } = useModule(resource);

  const tabsConfig = formTabsConfig || {};

  const tabs = Object.keys(tabsConfig).map((key, index) => {
    const isFirstTab = index === 0;
    const path = isFirstTab
      ? paths.create.root
      : paths.create.tab(camelToKebabCase(key)).root;
    const tab = tabsConfig[key];
    return {
      path: path,
      title: tab.title,
      isDisabled: index !== 0,
      disabledTooltip:
        tab.disabledTooltip ??
        t("disabledFunctionality", {
          ns: TranslationNamespaceEnum.FormComponent,
        }),
      isHidden: tab.isHidden,
      key,
    };
  });

  if (tabs.length > 0) {
    return (
      <TabsFormLayoutV2
        layoutForm={layoutForm}
        type={FormAction.Create}
        tabs={tabs}
        resource={resource}
      />
    );
  }

  return <Outlet />;
}
